export const ServerRouterStore = {
  namespaced: true,
  state: {
    serverRouter: undefined
  },
  actions: {
    refershServerRouter({ commit }, action) {
      commit("setServerRouter", action.payload);
    }
  },
  mutations: {
    setServerRouter(state, payload) {
      state.serverRouter = payload;
    }
  },
  getters: {
    serverRouter: state => {
      return state.serverRouter;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/global/ServerRouterStore/ServerRouterStore.js